




















import { Component, Emit, Vue } from 'vue-property-decorator'
import 'mavon-editor/dist/css/index.css'
import { QueryBrochureById, CreateBrochure,UpdateBrochure } from '@/api'
import {getUrlKey} from '@/utils/request'
import { Message } from 'element-ui'
import mavonEditor from 'mavon-editor'
import FileUpload from '@/utils/fileupload/fileUpload'

const me = mavonEditor.mavonEditor

@Component({
  components: {
   me,
  },
})
export default class EditBrochure extends Vue {
  private data: any = {content:'', html:''}

  private fileUpload = new FileUpload()
  private show = false

  @Emit('close')
  private close() {
    this.data = {content:'', html:''}
    this.show = false
  }

  public open(id: number){
    this.data.id = id
    this.loadData()
    this.show = true
  }

  private created(param: any){
    this.data.id =  Number(getUrlKey('id'))
    this.loadData()
  }

  private async loadData(){
    if(this.data.id <= 0){
      return
    }
    const result = await QueryBrochureById({id: this.data.id})
    this.data = result
  }
  private async addImage(fileIndex: any, File: any){
    console.log('addImgToMd', fileIndex, File);

    const fr = await this.fileUpload.fileUpload(File)
    const md = this.$refs['md'] as any
    md.$img2Url(fileIndex, fr.url)
  }
  private change(value: any, render: any) {
    this.data.html = render
  }
  private  async click() {
    if(this.data.id <= 0){
      const id = await CreateBrochure(this.data)
      this.data.id = id
      Message.success("提交成功")
      this.close()
    }else{
      await UpdateBrochure(this.data)
      Message.success("提交成功")
      this.close()
    }
  }
}
